var _rect, _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLevelBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 63,
    viewBox: "0 0 190 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 190,
    height: 63,
    fill: "black",
    fillOpacity: 0.58
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-723 -682C-723 -683.105 -722.105 -684 -721 -684H4192C4193.1 -684 4194 -683.105 4194 -682V2292C4194 2293.1 4193.1 2294 4192 2294H-721C-722.105 2294 -723 2293.1 -723 2292V-682Z",
    fill: "#404040"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-721 -683H4192V-685H-721V-683ZM4193 -682V2292H4195V-682H4193ZM4192 2293H-721V2295H4192V2293ZM-722 2292V-682H-724V2292H-722ZM-721 2293C-721.552 2293 -722 2292.55 -722 2292H-724C-724 2293.66 -722.657 2295 -721 2295V2293ZM4193 2292C4193 2292.55 4192.55 2293 4192 2293V2295C4193.66 2295 4195 2293.66 4195 2292H4193ZM4192 -683C4192.55 -683 4193 -682.552 4193 -682H4195C4195 -683.657 4193.66 -685 4192 -685V-683ZM-721 -685C-722.657 -685 -724 -683.657 -724 -682H-722C-722 -682.552 -721.552 -683 -721 -683V-685Z",
    fill: "white",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_126_2078)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 995,
    transform: "translate(-20 -286)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 31,
    width: 190,
    height: 10,
    rx: 5,
    fill: "#1EB65B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.91 60V52.6H28.39V58.76H31.4V60H26.91ZM33.2258 60L31.3058 54.41H32.7958L33.6058 57.2C33.7558 57.75 33.9058 58.32 34.0558 58.89H34.1058C34.2558 58.32 34.4058 57.75 34.5558 57.2L35.3758 54.41H36.7958L34.9258 60H33.2258ZM37.913 60.14C37.383 60.14 37.003 59.73 37.003 59.18C37.003 58.63 37.383 58.23 37.913 58.23C38.433 58.23 38.833 58.63 38.833 59.18C38.833 59.73 38.433 60.14 37.913 60.14ZM40.3549 60V58.81H41.9549V54.33H40.6049V53.42C41.3549 53.27 41.8549 53.08 42.3349 52.79H43.4249V58.81H44.8149V60H40.3549Z",
    fill: "#12A054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.42 11V10.16C9.35 8.31 10.62 7.06 10.62 5.98C10.62 5.25 10.23 4.81 9.52 4.81C8.97 4.81 8.54 5.18 8.16 5.58L7.35 4.78C8.03 4.05 8.7 3.66 9.71 3.66C11.1 3.66 12.04 4.54 12.04 5.91C12.04 7.16 10.87 8.47 9.55 9.85C9.92 9.81 10.41 9.76 10.76 9.76H12.38V11H7.42ZM15.8484 11.14C14.3184 11.14 13.3384 9.82 13.3384 7.37C13.3384 4.92 14.3184 3.66 15.8484 3.66C17.3584 3.66 18.3484 4.93 18.3484 7.37C18.3484 9.82 17.3584 11.14 15.8484 11.14ZM15.8484 9.99C16.4884 9.99 16.9584 9.38 16.9584 7.37C16.9584 5.36 16.4884 4.8 15.8484 4.8C15.2084 4.8 14.7284 5.36 14.7284 7.37C14.7284 9.38 15.2084 9.99 15.8484 9.99ZM19.5869 13.15V5.41H20.7769L20.8969 5.99H20.9269C21.3869 5.58 21.9669 5.27 22.5669 5.27C23.9469 5.27 24.7669 6.39 24.7669 8.12C24.7669 10.04 23.6169 11.14 22.3869 11.14C21.9069 11.14 21.4269 10.93 21.0069 10.54L21.0569 11.45V13.15H19.5869ZM22.0669 9.93C22.7369 9.93 23.2569 9.35 23.2569 8.14C23.2569 7.06 22.9269 6.47 22.1469 6.47C21.7769 6.47 21.4369 6.66 21.0569 7.05V9.52C21.4069 9.83 21.7669 9.93 22.0669 9.93ZM27.7402 11.14C26.4102 11.14 25.9002 10.3 25.9002 9.05V6.56H25.1202V5.47L25.9902 5.41L26.1502 3.89H27.3702V5.41H28.7602V6.56H27.3702V9.05C27.3702 9.69 27.6402 9.99 28.1302 9.99C28.3202 9.99 28.5302 9.92 28.6902 9.86L28.9302 10.93C28.6302 11.03 28.2402 11.14 27.7402 11.14Z",
    fill: "#12A054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 26.5C4.5 23.6667 9.7 18 18.5 18C27.3 18 32.1667 22.3333 33.5 24.5",
    stroke: "#BABABA",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.5,
    y1: 27.5,
    x2: 34.5,
    y2: 45.5,
    stroke: "#58C85A",
    strokeLinecap: "round",
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73.5,
    y1: 27.5,
    x2: 73.5,
    y2: 45.5,
    stroke: "#58C85A",
    strokeLinecap: "round",
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 112.5,
    y1: 27.5,
    x2: 112.5,
    y2: 45.5,
    stroke: "#58C85A",
    strokeLinecap: "round",
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 151.5,
    y1: 27.5,
    x2: 151.5,
    y2: 45.5,
    stroke: "#58C85A",
    strokeLinecap: "round",
    strokeDasharray: "3 3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_126_2078"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 995,
    fill: "white",
    transform: "translate(-20 -286)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevelBar);
export default __webpack_public_path__ + "static/media/level-bar.aa0e2f85a3394bca16f74424c2d0bf27.svg";
export { ForwardRef as ReactComponent };